module.exports = __webpack_public_path__ + "static/media/yello_band.a0d8c96b.png";